const getPaywallSeoClass = ({ className = "paywall", index = 3 }, blockIndex) => blockIndex < index && className;
const isPaywallSeo = (seoMode) => typeof seoMode === "object" && typeof seoMode.paywall === "object";

export { getPaywallSeoClass, isPaywallSeo };
//# sourceMappingURL=paywallSeo.js.map
